import { getAsyncState } from '../selectors';
export var getPaymentsState = getAsyncState('payments');
export var getPaymentByID = function (id, state) {
    var _a, _b;
    return ((_b = (_a = getPaymentsState(state).data) === null || _a === void 0 ? void 0 : _a.methods) === null || _b === void 0 ? void 0 : _b.find(function (m) { return m.id === id; }));
};
